// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios';

import VueSession from 'vue-session'
Vue.use(VueSession)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

// import * as VueDatepicker from 'vue-datepicker';

const phoneRule = {
  getMessage(field, args) {
    return `The ${field} must be either a valid phone number`
  },
  validate(value, args) {
    // Custom regex for a phone number
    const MOBILEREG = /^(1[ \-\+]{0,3}|\+1[ -\+]{0,3}|\+1|\+)?((\(\+?1-[2-9][0-9]{1,2}\))|(\(\+?[2-8][0-9][0-9]\))|(\(\+?[1-9][0-9]\))|(\(\+?[17]\))|(\([2-9][2-9]\))|([ \-\.]{0,3}[0-9]{2,4}))?([ \-\.][0-9])?([ \-\.]{0,3}[0-9]{2,4}){2,3}$/

    console.log('asd')

    // Check for either of these to return true
    return MOBILEREG.test(value)
  },
}
VeeValidate.Validator.extend('phone', phoneRule)

const streetAddressRule = {
  getMessage(field, args) {
    return `The ${field} must be either a valid address`
  },
  validate(value, args) {
    return (
      value.length > 10 &&
      /\s/.test(value) &&
      /[A-Za-z]+/.test(value) &&
      /[0-9]+/.test(value)
    )
  },
}
VeeValidate.Validator.extend('streetAddress', streetAddressRule)

import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton)

import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

import App from './App'

import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

Vue.config.productionTip = false

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import router from './routes.js'

var AddToCalendar = require('vue-add-to-calendar')
Vue.use(AddToCalendar)

import VueResource from 'vue-resource'
Vue.use(VueResource)
Vue.http.options.emulateJSON = true
const http = Vue.http
export default http

import vueSignature from 'vue-signature'
Vue.use(vueSignature)

import GetTextPlugin from 'vue-gettext'
import translations from './data/i18n.json'

var StarRating = require('vue-star-rating')
Vue.component('star-rating', StarRating.default)

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

var toastrConfigs = {
  timeOut: 5000,
  showDuration: 1000,
  hideDuration: 1000,
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
  position: 'top right',
  toastrType: 'success',
  closeButton: true,
  progressBar: true,
}
import CxltToastr from 'cxlt-vue2-toastr'
Vue.use(CxltToastr, toastrConfigs)

window.tokenmain = {
  contractAddressTest: '0xfdbef055ede762a7e3e3f33b3146cee3499b5192',
  contractAddress: '0x626F0a4b79E924016cA7B7CE003C238b819206b8',
  contractABI: JSON.parse(
    '[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"claim","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"version","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"_initialAmount","type":"uint256"},{"name":"_tokenName","type":"string"},{"name":"_decimalUnits","type":"uint8"},{"name":"_tokenSymbol","type":"string"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_from","type":"address"},{"indexed":true,"name":"_to","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}]'
  ),
}

// import all
import {Datepicker, Timepicker, DatetimePicker} from '@livelybone/vue-datepicker';
Vue.component('datepicker', Datepicker);

window.wAddress = ''

Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'EN',
    es_US: 'ES',
    ru_RU: 'RU',
    ua_UA: 'UA',
    zh_ZH: 'CH',
    de_DE: 'DE',
    ko_KO: 'KO',
    ja_JA: 'JA',
  },
  defaultLanguage: 'en_US',
  languageVmMixin: {
    computed: {
      currentKebabCase: function() {
        return this.current.toLowerCase().replace('_', '-')
      },
    },
  },
  translations: translations,
  silent: true,
})

Vue.filter('two_digits', function(value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString()
  }
  return value.toString()
})

Vue.filter('filterDate', function(value) {
  if (value) {
    var monthNamesShort = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]

    var date = new Date(value),
      month = monthNamesShort[date.getMonth()],
      day = date.getDate(),
      year = date.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return month + '. ' + day + ', ' + year
  }

  return ''
})

import store from './store'

import VShowSlide from 'v-show-slide'
Vue.use(VShowSlide)

// import VShowSlide from './Plugins/VShowSlide.js'

// Vue.use(new VShowSlide(), {
//   customEasing: {
//     exampleEasing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)'
//   }
// })

new Vue({
  store, // inject store to all children
  el: '#app',
  template: '<App/>',
  components: {
    App,
  },
  data: {
    authenticated: false,
  },
  router,
})





// WEBPACK FOOTER //
// ./src/main.js